import { ParagraphAsHint, ParagraphAsLabel } from "App/global-style";

import { useTexts } from "Components/TextContext";
import { FormikProps } from "formik";
import React from "react";
import { CarProductDetailsFormValues } from "../interfaces";
import { BonusValue } from "./constant";

interface Props {
  formProps: FormikProps<CarProductDetailsFormValues>;
}

export const FirstCarInsurance = (props: Props): React.ReactElement => {
  const { getText } = useTexts();
  const { formProps } = props;

  React.useEffect(() => {
    formProps.setFieldValue("bonus", BonusValue.SIXTY);
  }, []);

  return (
    <>
      <ParagraphAsLabel>
        {getText("carform.label.bonusfirstinsurance")}
      </ParagraphAsLabel>
      <ParagraphAsHint>
        {getText("carform.hint.bonusfirstinsurance")}
      </ParagraphAsHint>
    </>
  );
};
